import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { NewbuildingMvkContext } from '../../../../shared/context';
import { fetchSimilarFlats } from '../../../../services';
export var useFlats = function useFlats(_ref) {
  var offerId = _ref.offerId;
  var _React$useContext = React.useContext(NewbuildingMvkContext),
    httpApi = _React$useContext.httpApi,
    logger = _React$useContext.logger;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isError = _React$useState2[0],
    setIsError = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLoading = _React$useState4[0],
    setIsLoading = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    flats = _React$useState6[0],
    setFlats = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    title = _React$useState8[0],
    setTitle = _React$useState8[1];
  var loadFlats = React.useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var offerId, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            offerId = _ref2.offerId;
            setIsError(false);
            setIsLoading(true);
            _context.next = 5;
            return fetchSimilarFlats({
              params: {
                offerId: offerId
              },
              httpApi: httpApi,
              logger: logger
            });
          case 5:
            response = _context.sent;
            setIsLoading(false);
            if (response) {
              setFlats(response.offers || null);
              setTitle(response.title || null);
            } else {
              setIsError(true);
              setFlats(null);
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [offerId, httpApi, logger]);
  React.useLayoutEffect(function () {
    loadFlats({
      offerId: offerId
    });
  }, [offerId, loadFlats]);
  return {
    isError: isError,
    isLoading: isLoading,
    flats: flats,
    title: title
  };
};